import React, { useEffect, useReducer, useState } from 'react';
import { useConfig } from '../../../DataStore/ConfigContext';
import Notification from '../../Common/Notification';
import CallOut from '../../Common/CallOut';
import TextInput from '../../Common/TextInput';
import ActivityLoader from '../../Common/ActivityLoader';
import ajaxConfig from '../../../util/remote/ajaxConfig';

const reducer = (state, action)=>{
        if(action.type === "RESET"){
            return {...initialState}
        }
        return { ...state, [action.type]: action.value };
}

const initialState = {
    "school_name":'',
    "telephone":'',
    "address":'',
    "email_address":'',
    "motto":'',
    "short_name":'',
    "website":'',
}

const EditSchoolProfile = ({schoolProfile}) => {

    const [currentNotify, setNotify] = useState(null);
    const {getSchoolProfile} = useConfig();
    const [state, dispatch] = useReducer(reducer, initialState);

   
    useEffect(()=>{
        if(schoolProfile){
            dispatch({type: 'school_name', value: schoolProfile.school_name});
            dispatch({type: 'telephone', value: schoolProfile.telephone});
            dispatch({type: 'address', value: schoolProfile.address});
            dispatch({type: 'email_address', value: schoolProfile.email_address});
            dispatch({type: 'motto', value: schoolProfile.motto});
            dispatch({type: 'short_name', value: schoolProfile.short_name});
            dispatch({type: 'website', value: schoolProfile.website || ''});
        }
    }, [schoolProfile]);

    useEffect(()=>{
        if(currentNotify){
            setTimeout(() => {
                setNotify(null);
            }, 5000);
        }
    }, [currentNotify]);

    const handleSave = async (event) =>{
        event.preventDefault();
        const data = {
            school_name: state.school_name,
            telephone: state.telephone,
            address: state.address,
            email_address: state.email_address,
            motto: state.motto,
            short_name: state.short_name,
            website: state.website
        };
        const server_response = await ajaxConfig.updateSchoolInfo(data);
        if(server_response.status === "OK"){
            setNotify(<Notification type='success' message={server_response.message}/>);
            getSchoolProfile(true); // Refresh the school profile data
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>);
        }
    }


    const handleFormChange=(event)=>{
        const { name, value } = event.target;
        dispatch({type: name, value: value});
    }
  

    return (
        <div className="card-body">

            <CallOut 
                title="School Profile"
                description="Edit your school profile information here."
             />
            {currentNotify}
            <form className="form-horizontal" method="post" onSubmit={handleSave}>

               <TextInput
                    type="text"
                    label="School Name"
                    placeholder="School Name"
                    leftIcon="fa fa-info"
                    value={state.school_name}
                    name="school_name"
                    onChange={handleFormChange} 
                    required
                    wrap
                    />

                <TextInput
                    type="text"
                    label="School Address"
                    placeholder="School Address"
                    leftIcon="fa fa-map-pin"
                    value={state.address}
                    name="address"
                    onChange={handleFormChange} 
                    required
                    wrap
                    />


               <TextInput
                    type="text"
                    label="School Motto"
                    placeholder="School Motto"
                    leftIcon="fa fa-info"
                    value={state.motto}
                    name="motto"
                    onChange={handleFormChange} 
                    required
                    wrap
                    />


               <TextInput
                    type="text"
                    label="Telephone"
                    placeholder="Telephone"
                    leftIcon="fa fa-phone"
                    value={state.telephone}
                    name="telephone"
                    onChange={handleFormChange} 
                    required
                    wrap
                    />


                <TextInput
                    type="text"
                    label="Email Address"
                    placeholder="Email address"
                    leftIcon="fa fa-envelope"
                    value={state.email_address}
                    name="email_address"
                    onChange={handleFormChange} 
                    required
                    wrap
                    />
               
    
               <TextInput
                    type="text"
                    label="Website"
                    placeholder="Website"
                    leftIcon="fa fa-globe"
                    value={state.website}
                    name="website"
                    onChange={handleFormChange}
                    wrap 
                    />
                <TextInput
                    type="text"
                    label="Short Name"
                    placeholder="Short Name"
                    leftIcon="fa fa-star"
                    value={state.short_name}
                    name="short_name"
                    onChange={handleFormChange} 
                    required
                    wrap
                    />



                

                    <div className="text-right">
                        {!state.loading && <button type="submit" className="btn btn-lg btn-primary">Save Changes</button>}
                        {state.loading && <ActivityLoader />}
                    </div>

            </form> 


        </div>
    );
};

export default EditSchoolProfile;